import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.AUDIT_LOCATIONS_CLEAR: {
            return getInitialState.list();
        }
        case actionTypes.AUDIT_LOCATIONS_SET: {
            const { auditLocations } = action.payload;
            return helpers.getListReducer(state, auditLocations);
        }
        default: {
            return state;
        }
    }
}
